import {CurrentUser} from "../types/auth";

export const useLocalStorage = () => {
  const setAuthUserData = (data: CurrentUser) => {
    localStorage.setItem("authData", JSON.stringify(data))
  }
  const getAuthUserData = (): CurrentUser | undefined => {
    const data = localStorage.getItem("authData")
    if (!data) return undefined
    const user = JSON.parse(data)
    return {...user, labels: user.labels ?? []}
  }
  const clearAuthUserData = () => {
    localStorage.removeItem("authData")
  }
  return {setAuthUserData, clearAuthUserData, getAuthUserData}
}
